import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { produce } from 'immer';
import moment from 'moment';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { modalActionCreator } from '../../store/actions/modalActions';
import { Card, Button, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'
import { EmployeeUserService } from '../../services';

const formatDateTime = (date) => {
    const dt = moment(date)
    if (!dt.isValid()) {
        return 'Never';
    }
    let returnVal = '';
    const currDate = moment();
    const same = dt.isSame(currDate, 'day');
    const yesterday = dt.diff(currDate, 'days')
    if (same) {
        returnVal = dt.format('h:mm A') + ' today';
    } else {
        returnVal = dt.format('M/D/YY') + ' at ' + dt.format('h:mm A');
    }
    return returnVal;
}

const pageSize = 10;

class EmployeeUsers extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            viewModel: {
                employees: [],
                availableRoles: []
            },
            currentPage: 0,
            pagedEmployees: []
        };

        this.saveUser = this.saveUser.bind(this);
        this.filterSort = this.filterSort.bind(this);
        this.filterResults = this.filterResults.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handlePage = this.handlePage.bind(this);
    }

    componentDidMount() {
        this.ensureDataFetched();
    }

    async ensureDataFetched() {
        var userService = new EmployeeUserService();
        var callResult = await userService.getUsers();
        if (callResult.result) {
            //let vm = { ...this.state.viewModel };
            //vm.employees = callResult.model;
            callResult.model.employees = this.filterSort(callResult.model.employees);
            const pagedResults = _.chunk(callResult.model.employees, pageSize);
            this.setState({ viewModel: callResult.model, pagedEmployees: pagedResults, currentPage: 0 });
        }
    }

    async saveUser(user) {
        var userService = new EmployeeUserService();
        var result = await userService.createUser(user);
        if (result.result) {
            // notify parent container of new user
            const nextState = produce(this.state, draft => {
                draft.viewModel.employees.push(result.model);
                draft.viewModel.employees = this.filterSort(draft.viewModel.employees);
                draft.currentPage = 0;
                draft.pagedEmployees = _.chunk(draft.viewModel.employees, pageSize);
            });

            this.setState(nextState);
            return result;
        }
        else {
            return result;
        }
    }

    filterSort(employees) {
        var sorted = employees.sort((a, b) => (a.lastName.toLowerCase() > b.lastName.toLowerCase()) ? 1 : -1)
        return sorted;
    }

    filterResults() {
        const search = this.state.searchText.toLowerCase();
        const employees = this.state.viewModel.employees;

        // filter main results
        const filteredData = employees.filter(employee => employee.fullName.toLowerCase().includes(search));
        // chunk those results into pages
        const pagedResults = _.chunk(filteredData, pageSize);

        // update state
        this.setState({ pagedEmployees: pagedResults, currentPage: 0 });
    }

    handleSearch(e) {
        const text = e.target.value;
        this.setState({ searchText: text }, () => this.filterResults());
    }

    handlePage(page) {
        var nextState = produce(this.state, draft => {
            draft.currentPage = page.selected;
        })
        this.setState(nextState);
    }
    
    renderUserTable() {
        return (
            <table className='table table-striped table-hover' aria-labelledby="tabelLabel">
                <thead>
                <tr>
                        <th>
                            <Form.Control value={this.state.searchText}
                                className="borderless-control"
                                name="searchText" id="searchText"
                                size="sm" placeholder="Name"
                                onChange={this.handleSearch} />
                        </th>
                        <th>Email Address</th>
                        <th>Role</th>
                    <th>Last Login</th>
                        <th>State</th>
                    <th className="table-fit" />
                </tr>
                </thead>
                <tbody>
                {this.state.pagedEmployees[this.state.currentPage]?.map((emp) =>
                    <tr key={emp.id}>
                        <td>{emp.fullName}</td>
                        <td>{emp.emailAddress}</td>
                        <td>{emp.role?.name}</td>
                        <td>{formatDateTime(emp.lastLogin)}</td>
                        <td>{emp.stateName}</td>
                        <td className="table-fit">
                            <LinkContainer to={'/admin/users/' + emp.id}>
                                <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
                            </LinkContainer>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        );
    }

    render() {
        return (
            <Card>
                <Card.Header className="d-flex align-items-center">
                    <div className="mr-auto" >Employee Users</div>
                    <div className="card-btn-group">
                        <Button variant="primary" size="sm" onClick={() => this.props.showModal({
                            open: true,
                            roles: this.state.viewModel.availableRoles,
                            closeModal: this.props.hideModal,
                            saveModel: this.saveUser
                        }, 'createEmployeeUser')}>Create</Button>
                    </div>
                </Card.Header>
                <Card.Body className="card-body-table">
                    { this.renderUserTable() }
                    {
                        this.state.pagedEmployees.length > 1 ?
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                //padding: 20,
                                boxSizing: 'border-box',
                                width: '100%',
                            }}>
                                <ReactPaginate
                                    activeClassName={'pagination-item pagination-active '}
                                    breakClassName={'pagination-item pagination-break-me '}
                                    breakLabel={'...'}
                                    containerClassName={'pagination-pagination'}
                                    disabledClassName={'pagination-disabled-page'}
                                    marginPagesDisplayed={2}
                                    nextClassName={'pagination-item pagination-next '}
                                    nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                                    onPageChange={this.handlePage}
                                    forcePage={this.state.currentPage}
                                    pageCount={this.state.pagedEmployees.length}
                                    pageClassName={'pagination-item pagination-page '}
                                    pageRangeDisplayed={2}
                                    previousClassName={'pagination-item pagination-previous'}
                                    previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                                />
                            </div> : null
                    }
                </Card.Body>
            </Card>
        );
    }

}

export default connect(null, dispatch => bindActionCreators(modalActionCreator, dispatch))(EmployeeUsers);
//export default EmployeeUsers;